/*
 * @Author: liqiang70 liqiang70@58.com
 * @Date: 2025-05-14 16:05:40
 * @LastEditors: liqiang70 liqiang70@58.com
 * @LastEditTime: 2025-09-04 14:41:17
 * @Description: 
 */
import React from 'react';
import { NavLink } from 'react-router-dom';
import { IMG_WOS } from '../../constants';
import "./index.scss";

const Header = () => {
    
    return (
        <header className='chefu-header'>
            <div className="chefu-header-main chefu-section-main">
                <div className="chefu-header-logo">
                    <NavLink to="/">
                        <img src={`${IMG_WOS}ssou9o6a__w402_h138.png`} alt="58车服logo" />
                    </NavLink>
                </div>
                <nav className="chefu-header-nav">
                    <NavLink to="/">首页</NavLink>
                    <NavLink to="/service">产品服务</NavLink>
                    <NavLink to="/aboutUs">关于我们</NavLink>
                </nav>
            </div>
        </header>
    )
}

export default Header;